<template>
  <scrollactive
    :modify-url="false"
    :offset="400"
    :scroll-offset="60"
    :duration="1000"
    @itemchanged="onSectionChange"
  >
    <div class="scrollactive-bg-line absolute left-1/2 bg-white" />
    <a
      v-for="(scrollLink, i1) in scrollActiveLinks"
      :id="`menu-item-${scrollLink.slug}`"
      :key="`menu-item-${scrollLink.slug}`"
      :href="`#${scrollLink.slug}`"
      class="scrollactive-item relative w-22px h-22px block rounded-full"
      :style="`${(i1 + 1 < scrollActiveLinks.length) ? 'margin-bottom: 16px;' : ''}`"
      :data-slug="scrollLink.slug"
      :title="htmlDecode(scrollLink.title)"
      @click="gtmScrollActiveClick(scrollLink.slug)"
    >
      <div class="scrollactive-item-outer absolute left-1/2 top-1/2 w-full h-full bg-primary border-white border-solid border rounded-full opacity-0" />
      <div class="scrollactive-item-inner absolute left-1/2 top-1/2 bg-white rounded-full" />
    </a>
  </scrollactive>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ScrollActive',

  computed: {
    ...mapState([ 'slug', 'scrolling', 'noScroll' ]),
    ...mapGetters([ 'highlights', 'scrollActiveLinks' ])
  },

  watch: {
    $route(to, from) {
      if (to.meta.reposition && from.meta.reposition) {
        this.updateScrollPosition()
      }
    }
  },

  mounted() {
    setTimeout(() => {
      // if (!this.$route.params.media_id) {
      this.updateScrollPosition()
      // }
    }, 200)
  },

  methods: {
    onSectionChange(event, currentItem) {
      if (!this.noScroll) {
        this.$router.push(currentItem.dataset.slug)
      }
    },
    updateScrollPosition() {
      if (!this.scrolling) {
        document.getElementById(`menu-item-${this.$route.params.highlight_id}`).click()
      }
    },
    gtmScrollActiveClick(dot) {
      window.dataLayer.push({
        event: 'scrollDotClick',
        scrollDotClicked: dot
      })
    }
  }
}
</script>

<style scoped>
  /* TODO: Remove all tailwind classes and keep in all css to make easier to read */
.scrollactive-bg-line {
  top: 11px;
  bottom: 11px;
  width: 1px;
  transform: translateX(-50%);
}

.scrollactive-item {
  width: 22px;
  height: 22px;
}

.scrollactive-item .scrollactive-item-outer {
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.4s, opacity 0.4s;
}

.scrollactive-item .scrollactive-item-inner {
  width: 8px;
  height: 8px;
  transform: translate(-50%, -50%);
}

.scrollactive-item.is-active .scrollactive-item-outer {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}

@screen lg {
  .scrollactive-item:hover .scrollactive-item-outer {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}
</style>
